import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { loadState, saveState } from './index';
import { Api } from '../App';

// Define a type for the slice state
export interface MachineState {
    rigidity: number;
    spindle: string;
    toolHolder: string;

    toolPath: string;
    drillCycle: string;

    maxRPM: number;
    maxFeed: number;
}

export const maxRPM = 18000;
export const maxFeedIPM = 800;
export const maxFeedMMPM = 20000;

const placeholderState = {
    rigidity: 5,
    spindle: 'CV40',
    toolHolder: 'weldon',

    toolPath: 'offset',
    drillCycle: 'std',

    maxRPM, // 12,000 RPM
    maxFeed: maxFeedIPM, // 800 IPM / 20,000 MMPM
}

// Define the initial state using that type
const initialState: MachineState = loadState('machine', placeholderState);

export const counterSlice = createSlice({
    name: 'machine',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        set(state, action: PayloadAction<MachineState>) {
            Object.keys(action.payload).forEach(key => {
                // @ts-ignore
                state[key] = action.payload[key];
            })
            saveState('machine', state);
        },
        reset(state) {
            Object.keys(placeholderState).forEach(key => {
                // @ts-ignore
                state[key] = placeholderState[key];
            })
            if (Api.units === "METRIC") state.maxFeed = maxFeedMMPM;

            saveState('machine', state);
        },
        setRigidity: (state, action: PayloadAction<number>) => {
            state.rigidity = action.payload;
            saveState('machine', state);
        },
        setSpindle: (state, action: PayloadAction<string>) => {
            state.spindle = action.payload;
            saveState('machine', state);
        },
        setToolHolder: (state, action: PayloadAction<string>) => {
            state.toolHolder = action.payload;
            saveState('machine', state);
        },
        setToolPath: (state, action: PayloadAction<string>) => {
            state.toolPath = action.payload;
            saveState('machine', state);
        },
        setDrillCycle: (state, action: PayloadAction<string>) => {
            state.drillCycle = action.payload;
            saveState('machine', state);
        },
        setMaxFeed: (state, action: PayloadAction<number>) => {
            state.maxFeed = action.payload;
            saveState('machine', state);
        },
        setMaxRPM: (state, action: PayloadAction<number>) => {
            state.maxRPM = action.payload;
            saveState('machine', state);
        }
    },
})

export const { set, reset, setRigidity, setSpindle, setToolHolder, setToolPath, setDrillCycle, setMaxFeed, setMaxRPM } = counterSlice.actions;

export default counterSlice.reducer
